import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Capacitor } from '@capacitor/core';
import { Share } from '@capacitor/share';
import { ModalController, Platform } from '@ionic/angular';
import * as FileSaver from 'file-saver';
import { FullscreenService } from 'src/app/_provider/fullscreen.service';
import { ResizeManagerService } from 'src/app/_provider/resize-manager.service';
import { BreadcrumbCustomOptions } from 'src/app/_template/fullscreen-modal/breadcrump-header/breadcrump-header.component';

@Component({
    selector: 'app-image-view',
    templateUrl: './image-view.page.html',
    styleUrls: ['./image-view.page.scss'],
    standalone: false
})
export class ImageViewPage implements OnInit {


  public imagePath: string = ""
  public externalUrl: string = ""
  public filename: string = ""
  public isWeb: boolean = false

  public customBreadcrumbOptions: BreadcrumbCustomOptions = { 
    onBack: this.back.bind(this)
  }

  public get isApple(): boolean{
    const ua: string = navigator.userAgent;    
    return (this.platform.is("ios") || /Safari/.test(ua) && !/Chrome/.test(ua))
  }

  constructor(
    private modalCtrl: ModalController,
    private sanitizer: DomSanitizer,
    private fullscreenSrv: FullscreenService,
    public platform: Platform,
    public resizeManager: ResizeManagerService,
  ) { 
  }

  public get convertedPath(): SafeResourceUrl{
    return this.sanitizer.bypassSecurityTrustResourceUrl(Capacitor.convertFileSrc(this.imagePath))
  }

  ngOnInit() {

    this.customBreadcrumbOptions.breadcrumbs = [
      { name: this.filename }
    ]

    this.customBreadcrumbOptions.buttons = [
      {
        ionIcon: "fa-arrow-down",
        title: "Herunterladen",
        action: this.download.bind(this)
      },
      {
        ionIcon: "fa-open-new",
        title: "In neuem Tab öffnen",
        action: this.openExternal.bind(this)
      },
    ]

    if(this.platform.is("capacitor"))
        this.customBreadcrumbOptions.buttons.push({
          ionIcon: "fa-share",
          title: "Teilen",
          action: this.share.bind(this)
      })

  }

  private openExternal(){
    window.open(this.externalUrl, "_blank")
  }

  public async back(){
    await this.modalCtrl.dismiss()
  }

  public async share(){
    await Share.share({
      title: this.filename,
      url: this.imagePath //`${this.platform.is("android") ? androidRoot : ""}${path}`
    })
  }

  public async download(){
    FileSaver.saveAs(this.imagePath, this.filename)
  }

  public async toogleFullscreen(): Promise<void> {
    await this.fullscreenSrv.openModalInFullscreen(ImageViewPage, this)
  }


}
